import { EarthIcon, LaptopOutlineIcon } from '@carboncopyco/icons';
import { DemoLinkAccessPolicy, DemoLinkPlatform } from '@carboncopyco/types';

export const DEMO_LINK_DEFAULT_FOR_CLIENT = 'Unknown opportunity';

export const demoLinkAccessPolicyTypes = {
  [DemoLinkAccessPolicy.WORKSPACE_RESTRICTED]: {
    label: 'Workspace Restricted',
    id: DemoLinkAccessPolicy.WORKSPACE_RESTRICTED,
    description:
      'Only people with access to the asset workspace can open the link',
  },
  [DemoLinkAccessPolicy.JOIN_TO_WORKSPACE]: {
    label: 'Organization Wide',
    id: DemoLinkAccessPolicy.JOIN_TO_WORKSPACE,
    description:
      'Any organization member can join the workspace and open the link',
  },
  [DemoLinkAccessPolicy.PERMISSIVE]: {
    label: 'Permissive',
    id: DemoLinkAccessPolicy.PERMISSIVE,
    description:
      'People outside the asset workspace are allowed only to present',
  },
};

export const demoLinkPlatformTypes = {
  [DemoLinkPlatform.web]: {
    label: 'Web',
    id: DemoLinkPlatform.web,
    icon: EarthIcon,
    description: 'Convenient for quick access from any browser.',
  },
  [DemoLinkPlatform.desktop]: {
    label: 'Desktop',
    id: DemoLinkPlatform.desktop,
    icon: LaptopOutlineIcon,
    description: 'Best for full feature access and smooth performance',
  },
};
